<template>
  <div>
    Page not found
  </div>
</template>

<script>
  export default {
    name: 'page-404',
    props: {
    },
    data () {
        return {}
    },
    computed: {
    },
    mounted () {

    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Page404.vue